function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { isSafeUrl } from './utils';
// Construct features string to spec https://developer.mozilla.org/en-US/docs/Web/API/Window/open#windowfeatures
const featuresToString = (features)=>{
    return Object.keys(features).map((key)=>{
        const value = features[key];
        return `${key}=${value}`;
    }).join(',');
};
/**
 * Opens a new resource with the given URL into a new browsing context (i.e. tab, window, or iframe).
 * Use this instead of the native method: `window.open()`
 * This applies additional security measures to prevent malicious URLs from being opened.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/open
 * @deprecated Use `safeWindowOpen` instead.
 * @example
 * ```
 * windowOpen("/user-feedback", "_blank", "noopener noreferrer"); // equivalent to window.open("/user-feedback", "_blank", "noopener noreferrer")
 * ```
 * @param url The URL to be opened. If a string is passed, it is parsed as a URL
 * @param target The name of the browsing context (e.g. tab, window, or iframe). _self, _blank, _parent, or _top can also be used. If omitted, it defaults to _blank
 * @param features A string containing a comma-separated list of window features given with their corresponding values (e.g. "height=400,width=400,top=100,left=100")
 */ export const windowOpen = (url, target, features, options)=>{
    if (url && !isSafeUrl(url, options)) {
        return;
    }
    return window.open(url, target, features);
};
/**
 * Opens a new resource with the given URL into a new browsing context (i.e. tab, window, or iframe).
 * Use this instead of the native method: `window.open()`
 * This applies additional security measures to prevent malicious URLs from being opened.
 * It also sets `noopener` and `noreferrer` features by default.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/open
 * @example
 * ```
 * safeWindowOpen("/user-feedback", "_blank", {width: 400, height: 400}); // equivalent to window.open("/user-feedback", "_blank", "width=400,height=400,noopener=true,noreferrer=true")
 * ```
 * @param url The URL to be opened. If a string is passed, it is parsed as a URL
 * @param target The name of the browsing context (e.g. tab, window, or iframe). _self, _blank, _parent, or _top can also be used. If omitted, it defaults to _blank
 * @param features A map containing window features
 */ export const safeWindowOpen = (url, target, features, options)=>{
    if (url && !isSafeUrl(url, options)) {
        return;
    }
    // Set default features
    const fullFeatues = _object_spread({
        noopener: true,
        noreferrer: true
    }, features);
    const featuresStr = featuresToString(fullFeatues);
    return window.open(url, target, featuresStr);
};

//# sourceMappingURL=window.js.map